import Paths from "@/router/indexPaths"
const constant = {
  // コメントの最大横幅(文字数)
  COMMENT_MAX_WIDTH: 30,

  // 棚卸連携時の警告閾値(日)
  TANA_CONFIRM_WARN_THRESHOLD: 0,

  // スタッフコードの最大長(文字数)
  STAFF_CODE_MAX_LENGTH: 10,

  // プルダウン用権限リスト
  ROLE: Object.freeze({
    ADMIN: Object.freeze({ id: '0' }),
    ZONE_MANAGER: Object.freeze({ id: '1' }),
    SITE_USER: Object.freeze({ id: '2' }),
  }),

  // メニューリスト
  // label: 画面に表示される文言
  // name:  遷移先パス
  // icon:  アイコン
  // code:  コード
  MENU_LIST: Object.freeze([
    Object.freeze({ name: Paths.DASHBOARD, icon: "mdi-account-details-outline", code: "DASHBOARD", }),
    Object.freeze({ name: Paths.USER, icon: "mdi-account-edit", code: "USER", }),
    Object.freeze({ name: Paths.NYUUKA, icon: "mdi-format-list-bulleted-square", code: "NYUUKA", }),
    Object.freeze({ name: Paths.SHUKKA, icon: "mdi-format-list-bulleted-square", code: "SHUKKA", }),
    Object.freeze({ name: Paths.ZAIKO_JAN_LIST, icon: "mdi-format-list-bulleted-square", code: "ZAIKO_JAN_LIST", }),
    Object.freeze({ name: Paths.TANAOROSHI, icon: "mdi-format-list-bulleted-square", code: "TANAOROSHI", }),
    Object.freeze({ name: Paths.TANAOROSHI_ADJUSTMENT_HISTORY, icon: "mdi-format-list-bulleted-square", code: "TANAOROSHI_ADJUSTMENT_HISTORY", }),
    Object.freeze({ name: Paths.ZAIKO_MOVE, icon: "mdi-format-list-bulleted-square", code: "ZAIKO_MOVE", }),
    Object.freeze({ name: Paths.SALES, icon: "mdi-format-list-bulleted-square", code: "SALES", }),
    Object.freeze({ name: Paths.ALARM_EVENTS, icon: "mdi-format-list-bulleted-square", code: "ALARM_EVENTS", }),
    Object.freeze({ name: Paths.SITEZONE, icon: "mdi-format-list-bulleted-square", code: "SITEZONE", }),
    Object.freeze({ name: Paths.TANAOROSHI_LIST, icon: "mdi-format-list-bulleted-square", code: "TANAOROSHI_LIST", }),
    Object.freeze({ name: Paths.COOPERATION_FILE_UPLOAD, icon: "mdi-format-list-bulleted-square", code: "COOPERATION_FILE_UPLOAD", }),
    Object.freeze({ name: Paths.PEOPLE_COUNTER, icon: "mdi-format-list-bulleted-square", code: "PEOPLE_COUNTER", }),
    Object.freeze({ name: Paths.POS_MOVEMENTS, icon: "mdi-format-list-bulleted-square", code: "POS_MOVEMENTS", }),
    Object.freeze({ name: Paths.EAS_PASSAGE, icon: "mdi-format-list-bulleted-square", code: "EAS_PASSAGE", }),
    Object.freeze({ name: Paths.OKURIJO_JISSEKI, icon: "mdi-format-list-bulleted-square", code: "OKURIJO_JISSEKI", }),
    Object.freeze({ name: Paths.LABEL_ORDER, icon: "mdi-file-document-edit-outline", code: "LABEL_ORDER", }),
    Object.freeze({ name: Paths.LABEL_STOCK, icon: "mdi-tag-multiple-outline", code: "LABEL_STOCK", })
  ]),
  // ユーザーステータス
  USER_STATUS: Object.freeze({
    // 0:有効
    VALID: 0,
    // 1:無効
    INVALID: 1
  }),
  // レスポンスステータス
  RESPONSE_STATUS: Object.freeze({
    // 0:成功
    SUCCESS: 0,
    // 1:失敗
    FAILURE: 1
  }),
  // 棚卸ステータス
  INVENTORY_STATUS: Object.freeze({
    // 1:未実施
    NOT_STARTED: 1,
    // 2:実施中
    STARTED: 2,
    // 3:保存済み
    SAVED: 3,
    // 4:確定済
    CONFIRMED: 4,
    // 5:連携中
    COOPERATING: 5,
    // 6:連携済
    COOPERATED: 6,
  }),
  /** 棚卸区分 */
  INVENTORY_MODE: Object.freeze({
    /** 0:ゼロ在庫 */
    ZERO: 0,
    /** 1:中継サーバ在庫 */
    RELAY: 1,
    /** 2:APV在庫(上位棚卸) */
    ERP: 2,
  }),
  /**
   * 会社ごとに旧仕様のまま残す振る舞い
   * table/<会社>.json の "LegacyBehavior" に列挙したものだけが旧仕様になる（未記載なら新仕様）
   */
  LEGACY_BEHAVIOR: Object.freeze({
    /** APV在庫(上位棚卸)でもゾーン別に棚卸差異画面へ移動でき、差異画面でゾーンを選べる */
    ERP_ZONE_DRILLDOWN: "erpZoneDrilldown",
    /** 棚卸差異の差異フィルタに「差異あり」を出さない */
    NO_HAS_DIFFERENCE_FILTER: "noHasDifferenceFilter",
    /** サイズCD列のソートをサイズ表示順マスタに従わず、文字列順にする */
    PLAIN_SIZE_SORT: "plainSizeSort",
    /** 棚卸情報追加の商品検索に /product/search を使う */
    ADD_JAN_PRODUCT_SEARCH: "addJanProductSearch",
  }),
};
export default constant;
